import '../animate/style.js';
import './main.scss';